import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Construction, ArrowLeft } from 'lucide-react';

const PortfolioPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-[#003366] to-[#003366]/90 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Portfolio</h1>
          <p className="text-lg text-white/90">
            Explore our complete collection of before & after transformations
          </p>
        </div>
      </section>

      {/* Coming Soon Content */}
      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-gray-50 rounded-2xl p-12 border-2 border-dashed border-gray-300">
            <div className="w-20 h-20 bg-[#003366]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Construction className="w-10 h-10 text-[#003366]" />
            </div>
            <h2 className="text-2xl font-bold text-[#003366] mb-4">
              More Projects Coming Soon
            </h2>
            <p className="text-gray-600 mb-8 max-w-md mx-auto">
              We're curating our best work to showcase here. Check back soon to see more of our kitchen, bathroom, basement, and whole-home transformations.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/remodeling">
                <Button className="bg-[#003366] hover:bg-[#003366]/90 text-white">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Back to Remodeling
                </Button>
              </Link>
              <Link to="/contact">
                <Button className="bg-[#CFB973] hover:bg-[#CFB973]/90 text-[#003366] font-semibold">
                  Start Your Project
                </Button>
              </Link>
            </div>
          </div>

          {/* Teaser */}
          <div className="mt-12">
            <p className="text-gray-500 text-sm">
              Want to see specific project types? <Link to="/contact" className="text-[#003366] font-medium hover:text-[#CFB973]">Contact us</Link> and we'll share relevant examples.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PortfolioPage;
